<template>
	<div id="video-mp4" class="video-mp4"
		:class="{ 'video-mp4-full': fulling }">
		<video
			ref="video"
			class="video-mp4-main"
      preload="true"
			playsinline="true"
			webkit-playsinline="true"
      :poster="img"
			:style="{ display: started ? 'block' : 'none' }"></video>
		<video-control
			ref="control"
			:style="{ opacity: started ? 1: 0 }"
			:currentTime="currentTime"
			:buffered="buffered"
			:duration="length"
			:playing="playing"
			:showFull="showFull && !isIos"
			:show="controllShow"
			@play="play"
			@seek="seek"
			@full="full" />
		<video-cover
			v-if="cover"
			v-show="!started"
			:img="img"
			:title="title"
			:length="length"
			@click="start">{{ title }}</video-cover>
	</div>
</template>

<script>
// ios终端

import VideoControl from './video-control/index.vue'
import VideoCover from './video-cover/index.vue'
// import { NativeMediaReporter } from '@edu-fe/reporter'
import { getWpsSid } from '@edu-fe/login'
import record, { clearTimer } from '../../lib/record'

const os = require('@edu-fe/os')
const main = document.getElementById('video-mp4')

const u = navigator.userAgent
/* eslint-disable */
const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // android终端
const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
/* eslint-enable */

export default {
  props: {
    title: [String],
    src: {
      type: String,
      require: true
    },
    cover: {
      type: Boolean,
      default: true
    },
    img: [String],
    length: [Number],
    playedTime: {
      type: Number,
      default: 0
    },
    isIos: {
      type: Boolean,
      default: false
    }
  },
  components: {
    VideoControl,
    VideoCover
  },
  data () {
    return {
      fullStyle: false,
      fulling: false, // 正在全屏
      playing: false, // 正在播放
      started: false, // 开始播放
      showFull: true, // 展示全屏按钮
      countPlay: 1, // 进入浏览器默认会直接start   计数代表如果第一次进入则显示封面
      currentTime: 0,
      buffered: 0,
      duration: 0,
      fullTimer: null,
      controllShow: true,
      isTimeSetted: false // 仅设置一次初试时间
    }
  },
  computed: {
    player () {
      console.log(this.$refs.video)
      return this.$refs.video
    }
  },
  watch: {
    // 切换播放地址时停止播放
    src (value) {
      this.stop()

      // this.player.src = value // wu
      this.player.src = 'http://v1-edu.wpscdn.cn/video_mp4_720/dc7840dea26c11e7a335fa163e2a3b23/dc7840dea26c11e7a335fa163e2a3b23.mp4'

      // this.start()
    },
    playedTime (value) {
      this.currentTime = value
    }
  },
  methods: {
    // 开始播放
    start () {
      this.$emit('onplay')
      if (this.started) {
        this.countPlay++
        this.player.play()
      } else {
        if (this.countPlay) {
          this.started = true
          this.player.src = this.src
          this.player.play()
        } else {
          this.countPlay++
        }
      }
    },
    // 播放
    play () {
      this.setCurrentTime()
      this.player[this.player.paused ? 'play' : 'pause']()
    },
    // 暂停
    pause () {
      if (this.player && !this.player.paused) {
        this.player.pause()
      }
    },
    resize () {
      if (this.player) {
        if (this.player.width() !== main.offsetWidth) { this.player.width(main.offsetWidth) }
        if (this.player.height() !== main.offsetHeight) { this.player.height(main.offsetHeight) }
      }
    },
    // 停止
    stop () {
      this.pause()
      this.player.src = ''
      this.started = false
    },
    // 指定
    seek (data) {
      this.player.currentTime = data.time
    },
    requestFullScreen (de) {
      if (de.webkitEnterFullScreen) {
        de.webkitEnterFullScreen()
      } else if (de.webkitRequestFullscreen) {
        de.webkitRequestFullscreen()
      } else if (de.requestFullScreen) {
        de.requestFullScreen()
      } else if (de.webkitRequestFullScreen) {
        de.webkitRequestFullScreen()
      } else if (de.mozRequestFullScreen) {
        de.mozRequestFullScreen()
      } else if (de.msRequestFullScreen) {
        de.msRequestFullScreen()
      }
    },
    exitFullscreen (de) {
      if (de.exitFullscreen) {
        de.exitFullscreen()
      } else if (de.webkitCancelFullScreen) {
        de.webkitCancelFullScreen()
      } else if (de.mozCancelFullScreen) {
        de.mozCancelFullScreen()
      } else if (de.msRequestFullScreen) {
        de.msRequestFullScreen()
      }
    },
    // 全屏
    full () {
      if (os.type === 'app' && os.name === 'wps') { // wpsAndroid
        this.controllShow = true
        if (this.fullStyle) {
          this.fullStyle = false
          this.fulling = false
          os.sdk.view.direction('y')
        } else {
          this.player.width = window.innerWidth + 'px'
          this.player.height = window.innerHeight + 'px'
          os.sdk.view.direction('x')
          this.fulling = true
          setTimeout(() => {
            this.fullStyle = true
          }, 300)
        }
      } else if ((os.type === 'app' && os.name === 'wpsIos') || os.type === 'weixin') { // wpsIos 或者 微信
        if (this.fulling) {
          this.exitFullscreen(this.player)
          this.fulling = false
          this.controllShow = true
        } else {
          this.requestFullScreen(this.player)
          this.fulling = true
          os.deviceType === 'ios'
            ? (this.controllShow = true)
            : (this.controllShow = false)
        }
      } else {
        this.fulling = !this.fulling
      }
    },
    setCurrentTime () {
      // 仅设置一次初始时间
      if (!this.isTimeSetted) {
        if (os.system === 'android') {
          setTimeout(() => {
            this.player.currentTime = this.playedTime
          }, 1000)
        } else {
          this.player.currentTime = this.playedTime
        }
        this.isTimeSetted = true
      } else {
        this.currentTime = this.player.currentTime
      }
    }
  },

  mounted () {
    // 创建上报
    // getWpsSid().then(id => {
    //   const player = this.player
    //   const chapterId = this.$route.query.chapterId

    //   record.report({
    //     el: player,
    //     chapterId,
    //     wpsSid: id
    //   })

    // })

    // 判断是否展示全屏按钮 showFull
    if (os.type === 'app' && os.name === 'wps' && this.$route.name === 'daily') {
      this.showFull = false
    }

    window.addEventListener('resize', () => {
      if (os.type === 'app' && os.name === 'wpsIos') return

      if (window.innerWidth > window.innerHeight) {
        this.fullStyle = true
      } else {
        this.fullStyle = false
      }
    })

    this.player.addEventListener('playing', () => {
      this.playing = true
      this.$emit('playing')
    }, false)

    this.player.addEventListener('play', () => {
      this.$emit('play')
    }, false)

    this.player.addEventListener('pause', () => {
      this.playing = false
      this.$emit('pause')
    }, false)

    this.player.addEventListener('timeupdate', () => {
      this.setCurrentTime()

      try {
        this.buffered = Math.ceil(this.player.buffered.end(0))
      } catch (e) {}
    },
    false
    )
  },

  beforeDestroyed () {
    this.player.pause()
  },
  destroyed () {}
}
</script>

<style lang="scss">
@charset "utf-8";
@import "../../style/main";

$global-width: 750;

:fullscreen {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2147483647;
  background: black;
  width: 100%;
  height: 100%;
}
.video-mp4 {
  position: relative;
  height: rem($g-player);

  &-main {
    @include afull;
    background-color: #000;
  }

  &-full {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    z-index: 999999999999; //$z-index-full;
    overflow: hidden;
  }
}

$global-width: 720;
</style>
